import store from '@/store'
import { conversationsObjectsNewUI } from './conditionalFeatureFlags'

const routeNameToFeatureFlagMap = {
  'conversations-id-v2': 'contact-conversation.pageupgrade',
  'manual-actions-v2': 'conversations.pageupgrade',
  'triggers-links-conversations-v3': 'conversations.pageupgrade',
  'conversations-templates-v2': 'conversations.pageupgrade',
  scoring: 'conversations.pageupgrade',
  'smart-list-v2': 'contacts.newListView',
  'contact_detail-v2': 'contact-conversation.pageupgrade',
  'bulk-actions-log-v2': 'contacts.pageupgrade',
  'contact_restore-v2': 'contacts.pageupgrade',
  'custom-values-settings-v2': 'contacts.pageupgrade',
  'tags-settings-v2': 'contacts.pageupgrade',
}

const isNewCRMObjectsSettingsAppEnabled = (locationId: string, routeName: string) => {
  const allowedAnyway = conversationsObjectsNewUI(locationId)
  const featureFlag = routeNameToFeatureFlagMap[routeName as keyof typeof routeNameToFeatureFlagMap]
  return featureFlag && (allowedAnyway || store.getters['featureFlags/getForLocation'](featureFlag))
}

export const getPageVersion = (locationId: any, routeName: any): number | undefined => {
  try {
    const pageVersion = isNewCRMObjectsSettingsAppEnabled(locationId as string, routeName as string) ? 1 : undefined
    return pageVersion
  } catch (e) {
    return undefined
  }
}
